import {createResponsePropCodesCache} from 'rfp/bid-manager/main/core/actions/action/gbta-file-upload/gbta-file-upload.service';
import {mainAPI} from 'root/angular-injector-provider';

export function matchBidsUsingPropCodes(bids, orderedPropKeys){
  return function (uploadedResponses) {
    return matchUploadedResponsesWithBidsUsingOrderedPropKeys(bids, uploadedResponses, orderedPropKeys);
  };
}

export function acceptSingleRowFirstMatch(bid, orderedPropKeys){
  return function (uploadedResponses) {
    if(uploadedResponses.length === 1) {
      const match = { data: uploadedResponses[0].data, message: `Matched to single response in file`, propCodeKey: 'data from row', propCode: '1' };
      return Promise.resolve([formatBidMatch(bid, match)]);
    } else {
      return matchUploadedResponsesWithBidsUsingOrderedPropKeys([bid], uploadedResponses, orderedPropKeys);
    }
  };
}

async function matchUploadedResponsesWithBidsUsingOrderedPropKeys(bids, uploadedResponses, propertyCodesToMatch = []){
  const bidsHotelCodes = await loadHotelCodes(bids);
  return bids.map(bid => {
    const match = matchCodes(bidsHotelCodes[bid._id], uploadedResponses, propertyCodesToMatch);
    return formatBidMatch(bid, match)
  });
}

function formatBidMatch(bid, match){
  return {
    id: bid._id,
    hotelName: bid.supplier.company.name,
    hotelAddress: bid.supplier.company.location.fullAddress,
    bid,
    ...match
  };
}

async function loadHotelCodes(bids) {
  const httpResponse = await mainAPI().getHotelsPropertyCodes(bids.map(bid => bid._id));
  return httpResponse.data.reduce((acc, codes) => {
    acc[codes._id] = createResponsePropCodesCache(codes);
    return acc;
  }, {});
}

function matchCodes(bidPropCodes, uploadedResponses, propCodeKeys = []){
  const bidPropCodeKeys = Object.keys(bidPropCodes) || [];
  const matches = bidPropCodeKeys.reduce((acc, key) => {
    acc[key] = [];
    return acc;
  }, {});

  findAllMatches();
  const bestMatch = pickBestMatch();
  return formatBestMatchResult(bestMatch);

  function findAllMatches() {
    uploadedResponses.forEach(r => {
      const responsePropCodes = r.propCodes;
      bidPropCodeKeys.forEach(key => {
        if (bidPropCodes[key] === responsePropCodes[key]) matches[key].push(r.data);
      });
    });
  }

  function pickBestMatch(){
    for(let i = 0, l = propCodeKeys.length; i < l; i++){
      const key = propCodeKeys[i];
      const matchesForKey = matches[key];
      if(matchesForKey && matchesForKey.length) return {
        matches: matchesForKey,
        propCodeKey: key,
      };
    }
  }

  function formatBestMatchResult(best){
    const bestMatches = best? best.matches: [];
    const propCodeKey = best? best.propCodeKey: bidPropCodeKeys[0];
    const propCode = bidPropCodes[propCodeKey];

    if(bestMatches.length === 1){
      return { data: bestMatches[0], message: `Matched to response with ${propCodeKey}: ${propCode}`, propCodeKey, propCode };

    } else if (!bestMatches.length) {
      return { error: true, message: `No match found for ${propCodeKey}: ${propCode}`, propCodeKey, propCode }

    } else {
      return { error: true, message: `Multiple matches found for ${propCodeKey}: ${propCode}`, propCodeKey, propCode }
    }
  }
}
